<template>
  <div class="maskBox">
    <div class="confirmWithdraw">
      <div class="title">{{setText($t('lang.cashWheel.confirmWithdraw'))}}</div>
      <div class="btnBox">
        <div class="Btn" @click="ok">{{$t('lang.cashWheel.ok')}}</div>
        <div class="BtnBox" @click="close">
          <div class="Btn2">{{$t('lang.cashWheel.cancel')}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal-confirmWithdraw',
  props: {
    value: {
      type: Number,
      default: 500
    },
    withDrawVal: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {}
  },
  methods: {
    setText (val) {
      return val.replace('{withDrawVal}', this.withDrawVal)
    },
    close () {
      this.$emit('closeModalConfirmWithdraw', 'cancel')
    },
    ok () {
      this.$emit('closeModalConfirmWithdraw', 'ok')
    }
  }
}
</script>

<style lang="less" scoped>
.maskBox{
  height: 100vh;
  width: 100%;
  position: fixed;
  background-color: rgba(0,0,0,0.8);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}
@keyframes expandBox {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.confirmWithdraw{
  width: 82.23vw;
  height: 66.94vw;
  color: #D9D9D9;
  font-weight: 700;
  font-size: 5.27vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14vw;
  border: 1px solid #888888;
  border-right: 2px solid #888888;
  border-left: 2px solid #888888;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(8px);
  border-radius: 1.243vw;
  animation: expandBox 0.2s ease-out forwards;
  .title{
    width: 56.38vw;
    text-align: center;
  }
  .btnBox{
    display: flex;
    flex-direction: column;
    gap: 3vw;
    .Btn{
      width: 65.913vw;
      height: 10.833vw;
      color: #000000;
      font-size: 4.44vw;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(90deg, #01B7D3 0%, #13C498 100%), #F1DAB0;
      border-radius: 1.388vw;
    }
    .BtnBox{
      width: 65.913vw;
      height: 10.833vw;
      background: rgba(0, 0, 0, 0.4);
      border-radius: 1.5vw;
      color: #888888;
      font-size: 4.44vw;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0.3vw;
      border: 1px solid #888888;
      .Btn2{
        height: 100%;
        width: 100%;
        background-color: #040202;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 1.5vw;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/cashWheel/modal-confirmWithdraw.vue